import React, { useMemo, useState, useEffect } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { useConfig } from '@peracto/peracto-config'

import { HydraTable, Heading, TextFilter, StyledCheckbox } from '@peracto/peracto-ui'

import { GET_LIST, useClient } from '@peracto/client'

const UserGroupsList = () => {
    const { client } = useClient()
    const [redirect, setRedirect] = useState()

    const config = useConfig()
    const { user } = config.get('features', {})

    useEffect(() => {
        if (!user?.userGroups) {
            setRedirect('/')
        }
    }, [user])

    // The 'selectable' property is used to define if the
    // column is available in the 'manage columns' dropdown
    const columns = useMemo(() => [
        {
            Header: 'Name',
            accessor: 'name',
            sortType: 'basic',
            Cell: row => (
                <Link to={`${window.location.pathname}/${row.row.original.identifier}`}>
                    {row.cell.value}
                </Link>
            ),
            selectable: false,
        },
        {
            Header: 'Identifier',
            accessor: 'identifier',
            sortType: 'basic',
            selectable: false,
        },
    ])

    const onFetchData = options => client(GET_LIST, 'user-groups', options)

    return (
        <>
            <Helmet>
                <title>User Groups | Peracto</title>
            </Helmet>
            {redirect && <Redirect to={redirect} />}

            <Heading name="User Groups"></Heading>

            <div className="row">
                <div className="col">
                    <div className="card card--transparent">
                        <div className="card-body">
                            <HydraTable columns={columns} onFetchData={onFetchData} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserGroupsList
